// extracted by mini-css-extract-plugin
export default {"row":"Coupon_row__re+u-","half":"Coupon_half__-OknW","button":"Coupon_button__9R0IT"};